import React from 'react';
import { Stack, Text, PrimaryButton, FontWeights } from 'office-ui-fabric-react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { CHECK_FOR_SIGNEDIN_USER_COMMAND } from './auth/actions';
import { SET_MEETING_COMMAND } from './meeting-creator/actions';
import { Header } from './components/header';
import { createDefaultMeetingInput } from './meeting-creator/models';
import { FormattedMessage } from 'react-intl';
import { translate } from './localization/translate';
import calendar from './images/calendar.svg';
const boldStyle = { root: { fontWeight: FontWeights.semibold } };
const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({
    checkForSignedInUser: () => dispatch({
        type: CHECK_FOR_SIGNEDIN_USER_COMMAND
    }),
    onNewMeeting: () => {
        dispatch({
            type: SET_MEETING_COMMAND,
            meeting: createDefaultMeetingInput()
        });
        dispatch(push('/createMeeting'));
    }
});
function CreateLandingPageComponent(props) {
    // Check for a signed-in user and go to the signin page if there isn't one
    const checkForSignedInUser = props.checkForSignedInUser;
    React.useEffect(() => {
        checkForSignedInUser();
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null),
        React.createElement(Stack, { className: "container", horizontalAlign: "center", verticalAlign: "center", verticalFill: true, tokens: {
                childrenGap: 35
            } },
            React.createElement("img", { className: "splashImage", src: calendar, alt: translate('createLandingPage.splash.altText') }),
            React.createElement(Text, { variant: "xLargePlus", styles: boldStyle },
                React.createElement(FormattedMessage, { id: "createLandingPage.schedule.header" })),
            React.createElement(Text, { variant: "medium" },
                React.createElement(FormattedMessage, { id: "createLandingPage.subheader" })),
            React.createElement(PrimaryButton, { className: "teamsButton", onClick: () => props.onNewMeeting(), ariaLabel: translate('createLandingPage.create.meeting.ariaLabel') },
                React.createElement(FormattedMessage, { id: "createLandingPage.create.meeting" })))));
}
export default connect(mapStateToProps, mapDispatchToProps)(CreateLandingPageComponent);
